import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import axios from "axios";
import moment from "moment";

const InventorygrnFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    date: moment.utc(new Date()).format('YYYY-MM-DD HH:mm:ss'),
  });
  const [newFormData, setNewFormData] = useState({});
  const [notes, setNotes] = useState([]);
  const [items, setItems] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const [itemsTmp, setItemsTmp] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseLocations, setWarehouseLocations] = useState([]);


  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().inventorygrnId) || (entity === 'inventory-grn' && id)) {
      apiCall('patch', '/api/v2/inventory-grn/' + (window.App.urlVars().inventorygrnId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderInventoryGrnList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/inventory-grn', data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderInventoryGrnList: Math.random()})
          setFormData(response.data.data);
          setNewFormData({});
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/inventory/inventory-grn/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('GET', '/api/v2/inventory-document-item' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setItems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    apiCall('GET', '/api/v2/warehouse')
      .then(response => {
        setWarehouses(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/warehouse-location')
      .then(response => {
        setWarehouseLocations(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('get', '/api/v2/inventory-document?search[type][operator]==&search[type][value]=TRANSFER_SUPPLIER')
      .then(response => {
        setNotes(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().inventorygrnId) || (entity === 'inventory-grn' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/inventory-grn/' + (window.App.urlVars().inventorygrnId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  useEffect(() => {
    if (formData.delivery_note) {
      if (formData?.delivery_note?.id) {
        setLazyParams({
          first: 0,
          rows: rows,
          page: 0,
          sortField: 'id',
          sortOrder: -1,
          filters: {
            inventory_document: {value: formData?.delivery_note?.id, matchMode: 'equals'}
          }
        })
      } else {
        setLazyParams({
          first: 0,
          rows: rows,
          page: 0,
          sortField: 'id',
          sortOrder: -1,
          filters: {
            inventory_document: {value: formData?.delivery_note, matchMode: 'equals'}
          }
        })
      }
    }
  }, [formData.delivery_note])

  useEffect(() => {
    if(formData.delivery_note) {
      loadLazyData()
    }
  }, [lazyParams])


  return (
    <div className={"inventorygrn-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="date" render={({input, meta}) => (
                <span className="p-field p-fluid">
                    <label htmlFor="date"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDate')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"date"}
                                       mask={"9999-99-99 99:99:99"}
                                       placeholder={t('dateTimeSecondsPlaceholder')}
                                       value={moment.utc(formData.date).local().format('YYYY-MM-DD HH:mm:ss')}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             date: new Date(e.value)
                                           })
                                           setNewFormData({
                                             ...newFormData,
                                             date: new Date(e.value)
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.date}
                                      locale="hu"
                                      dateFormat={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date: e.value
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          date: e.value
                                        })
                                      }}/>
                    </div>
                  {getFormErrorMessage(meta)}
                  </span>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="delivery_note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="delivery_note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDeliveryNote')}</label>
                  <span className={"p-d-block"}>
                              <Dropdown {...input}
                                        onChange={(e) => {
                                          setFormData({
                                            ...formData,
                                            delivery_note: e.target.value
                                          })
                                          setNewFormData({
                                            ...newFormData,
                                            delivery_note: e.target.value
                                          })
                                        }}
                                        value={formData?.delivery_note?.id || formData.delivery_note}
                                        options={window.App.sortDropdownOptions(notes, "document_number")}
                                        optionLabel="document_number"
                                        optionValue="id"
                                        id={"delivery_note"}
                                        emptyMessage={t('noDeliveryNoteYet')}
                                        className={classNames({'p-error': isFormFieldValid(meta)})}
                              />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-text-right p-col-align-center"}>
              {formData.id && (
                <Button type="button" label="Befejezés"
                        loading={loading}
                        icon={'pi pi-check'}
                        disabled={formData.closed === true || items.length === 0}
                        className="p-button-warning p-ml-2"
                        onClick={() => {
                          setLoading(true);
                          apiCall('put', '/api/v2/inventory-grn/' + formData.id + '/close',
                            {}
                          )
                            .then(response => {
                              window.App.toastShow('success', 'Sikeres befejezés!');
                              window.App.setState({rerenderInventoryGrnList: Math.random()});
                              setFormData(response.data.data);
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                            })
                            .finally(() => {
                              setLoading(false);
                            });
                        }}/>
              )}
              {entity === 'inventory-grn' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        disabled={formData.closed === true}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      disabled={formData.closed === true}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>

          {id &&
            <div className={"p-grid p-mt-3"}>
              <div className={"p-col-12 p-lg-12"}>
                <h4 className={"p-mt-0"}>Termékek</h4>
                <DataTable
                  emptyMessage={t('noResults')}
                  size={"small"}
                  value={items} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                  onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                  onFilter={onFilter} filters={lazyParams.filters} lazy
                  paginatorTemplate={pager} rows={rows}
                  autoLayout={true}
                  filterDisplay="row"
                  responsiveLayout="scroll"
                  stripedRows
                  ref={dt}
                  dataKey="id"
                >
                  <Column field="material.name" header={t('columnName')} sortable filter></Column>
                  <Column header={t('columnQuantity')} sortable body={(rowData) => {
                    return (
                      <>
                        {Number(rowData?.quantity)} {rowData?.unit?.name}
                      </>
                    )
                  }}></Column>
                  <Column header={t('fieldWarehouseTo')} body={(rowData) => {
                    return (
                      <Dropdown showClear
                                onChange={(e) => {
                                  itemsData[rowData.id] = {...itemsData[rowData.id], warehouse: e.value};
                                  window.App.forceUpdate()
                                }}
                                value={itemsData[rowData.id]?.warehouse}
                                options={window.App.sortDropdownOptions(warehouses, "name")}
                                optionLabel="name"
                                optionValue="id"
                                emptyMessage={t('noWarehouseYet')}
                                className={"p-inputtext-sm"}
                      />
                    )
                  }}></Column>
                  <Column header={t('fieldWarehouseTo')} body={(rowData) => {
                    return (
                      <Dropdown showClear
                                onChange={(e) => {
                                  itemsData[rowData.id] = {...itemsData[rowData.id], warehouse_location: e.value};
                                  window.App.forceUpdate()
                                }}
                                value={itemsData[rowData.id]?.warehouse_location}
                                options={window.App.sortDropdownOptions(warehouseLocations, "code")}
                                optionLabel="code"
                                optionValue="id"
                                emptyMessage={t('noWarehouseYet')}
                                className={"p-inputtext-sm"}
                      />
                    )
                  }}></Column>
                  <Column body={(rowData) => {
                    return (
                      <React.Fragment>
                        {localStorage.getItem('roles').toString().includes('role_') &&
                          <Button icon="pi pi-save" className="p-button-success p-button-sm"
                                  tooltip={t('save')} tooltipOptions={{position: 'left'}}
                                  type="button"
                                  disabled={itemsTmp?.includes(rowData.id)}
                                  onClick={() => {
                                    setLoading(true);
                                    itemsTmp.push(rowData.id)
                                    setLoading(false);
                                    window.App.toastShow('success', 'Sikeres mentés!');
                                    window.App.forceUpdate()
                                    // apiCall('post', '/api/v2/inventory-grn-item', {
                                    //   inventory_grn: Number(id),
                                    //   warehouse: itemsData[rowData.id].warehouse,
                                    //   warehouse_location: itemsData[rowData.id].warehouse_location,
                                    //   delivery_note_item: rowData.id,
                                    // })
                                    //   .then(response => {
                                    //     window.App.toastShow('success', 'Sikeres mentés!');
                                    //
                                    //   })
                                    //   .catch(error => {
                                    //     window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                    //   })
                                    //   .finally(() => {
                                    //     setLoading(false);
                                    //   })
                                  }}
                          />
                        }
                      </React.Fragment>
                    );
                  }} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
                </DataTable>
              </div>
            </div>
          }

        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(InventorygrnFormComponent);
